import { AlertCircle, CheckCircle, Circle, Clock, XCircle } from 'lucide-react';
import React from 'react';
import { TaskStatus } from '../types/task';
import { Badge } from './ui/badge';

interface TaskStatusBadgeProps {
  status: TaskStatus;
}

const TaskStatusBadge: React.FC<TaskStatusBadgeProps> = ({ status }) => {
  const getStatusConfig = (status: TaskStatus) => {
    switch (status) {
      case TaskStatus.PENDING:
        return {
          label: 'Pending',
          variant: 'secondary' as const,
          icon: <Circle className="h-3 w-3" />,
        };
      case TaskStatus.ASSIGNED:
        return {
          label: 'Assigned',
          variant: 'default' as const,
          icon: <Clock className="h-3 w-3" />,
        };
      case TaskStatus.IN_PROGRESS:
        return {
          label: 'In Progress',
          variant: 'warning' as const,
          icon: <Clock className="h-3 w-3 animate-pulse" />,
        };
      case TaskStatus.COMPLETED:
        return {
          label: 'Completed',
          variant: 'default' as const,
          icon: <CheckCircle className="h-3 w-3" />,
        };
      case TaskStatus.BLOCKED:
        return {
          label: 'Blocked',
          variant: 'destructive' as const,
          icon: <AlertCircle className="h-3 w-3" />,
        };
      case TaskStatus.CANCELLED:
        return {
          label: 'Cancelled',
          variant: 'outline' as const,
          icon: <XCircle className="h-3 w-3" />,
        };
      default:
        return {
          label: status,
          variant: 'secondary' as const,
          icon: <Circle className="h-3 w-3" />,
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Badge variant={config.variant} className="flex items-center gap-1">
      {config.icon}
      {config.label}
    </Badge>
  );
};

export default TaskStatusBadge;
